import { required, maxLength, numeric, minValue, maxValue } from 'vuelidate/lib/validators'

const ipDns = value => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true
  }
  return (
    /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/.test(
      value
    ) ||
    /^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9]*[a-zA-Z0-9])\.)*([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9]*[A-Za-z0-9])$/.test(
      value
    )
  )
}

const contactUser = value =>{
  return /^.*$/.test(value)
}


export const validateData = {
  form: {
    description: { required, maxLength: maxLength(30) },
    ipServidor: { required, ipDns },
    domain: { ipDns },
    porta: { required, minValue: minValue(1024), maxValue: maxValue(65535), numeric },
    quality: { required },
    dtmf: { required },
    contactUser: { contactUser }
  },
}

export const validateComputed = {
  descriptionErrors() {
    const errors = []
    if (!this.$v.form.description.$dirty) return errors
    !this.$v.form.description.required && errors.push('Nome é obrigatório.')
    !this.$v.form.description.maxLength && errors.push('Nome não pode conter mais de 30 caracteres.')
    return errors
  },
  ipServidorErrors() {
    const errors = []
    if (!this.$v.form.ipServidor.$dirty) return errors
    !this.$v.form.ipServidor.required && errors.push('Endereço é obrigatório.')
    !this.$v.form.ipServidor.ipDns && errors.push('IP ou DNS não é válido.')
    return errors
  },
  fromDomainErrors() {
    const errors = []
    if (!this.$v.form.domain.$dirty) return errors
    !this.$v.form.domain.ipDns && errors.push('IP ou DNS não é válido.')
    return errors
  },
  portaErrors() {
    const errors = []
    if (!this.$v.form.porta.$dirty) return errors
    !this.$v.form.porta.required && errors.push('Porta é obrigatória.')
    !this.$v.form.porta.minValue && errors.push('Porta entre 1024 e 65535.')
    !this.$v.form.porta.maxValue && errors.push('Porta entre 1024 e 65535.')
    !this.$v.form.porta.numeric && errors.push('Apenas caracteres numéricos são aceitos neste campo.')
    return errors
  },
  qualityErrors() {
    const errors = []
    if (!this.$v.form.quality.$dirty) return errors
    !this.$v.form.quality.required && errors.push('Quality é obrigatória.')
    return errors
  },
  dtmfErrors() {
    const errors = []
    if (!this.$v.form.dtmf.$dirty) return errors
    !this.$v.form.dtmf.required && errors.push('DTMF é obrigatório.')
    return errors
  },

  contactUserErrors() {
    const errors = []
    if (!this.$v.form.dtmf.$dirty) return errors
    !this.$v.form.contactUser.contactUser && errors.push('Contato e alfanumerico')
    return errors
  },
}
